<template>
  <div class="v-view swiper-view a-fadeIn" :style="{ height: span * 33.33 + '%' }">
    <div class="v-title">{{ title }}</div>

    <div class="sv-header">
      <span v-for="(item, index) in swiperHeader" :key="index">
        {{ item }}
      </span>
    </div>
    <swiper v-if="swiperList.length > 0" ref="swiper" class="sv-swiper" :options="swiperOption">
      <swiper-slide class="sv-swiper-slide" v-for="(item, index) in swiperList" :key="index">
        <span>{{ item.name }}</span>
        <span>{{ item.year }}</span>
        <span>{{ item.month }}</span>
        <span>{{ item.day }}</span>
      </swiper-slide>
    </swiper>
    <div v-else class="sv-nodata">暂无数据!</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { numToThousands } from '@/utils';

export default {
  name: 'BuffetStatis',
  computed: {
    ...mapGetters(['cid']),
  },
  props: {
    span: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: '助餐服务统计',
    },
  },
  watch: {
    swiperData(data) {
      this.swiperList = data.map((item) => ({
        name: item.CompanyName,
        year: numToThousands(item.CurrentYear),
        month: numToThousands(item.CurrentMonth),
        day: numToThousands(item.CurrentDay),
      }))
      this.$nextTick(() => {
        if (!this.swiper) {
          this.swiper = this.$refs.swiper && this.$refs.swiper.swiper
        }
        this.swiper && this.swiper.slideToLoop(0, 0, false)
      })
    },
  },
  data() {
    this.slidesCount = this.span * 5
    return {
      dataInterval: null,
      swiper: null,
      swiperData: [],
      swiperList: [],
      swiperHeader: ['助餐机构', '当年', '当月', '当日'],
      swiperOption: {
        direction: 'vertical',
        slidesPerView: this.slidesCount,
        speed: 1000,
        loop: true,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
      },
    }
  },
  created() {
    this.getBuffetStatisData(this.cid)
  },
  beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy()
      this.swiper = null
    }
    if (this.dataInterval) {
      clearInterval(this.dataInterval)
      this.dataInterval = null
    }
  },
  methods: {
    getBuffetStatisData(cid) {
      this.$api
        .getBuffetStatis(cid)
        .then((data) => {
          // console.log(data)
          if (!data || !data.length) return
          if (data.length < this.slidesCount) {
            const dataLen = data.length
            const arr = Array.from({ length: this.slidesCount - dataLen }, () => {
              const index = Math.floor(Math.random() * dataLen)
              return data[index]
            })
            this.swiperData = data.concat(arr)
          } else {
            this.swiperData = data
          }
          if (!this.dataInterval) {
            const interval = this.swiperData.length * 4000
            this.dataInterval = setInterval(() => {
              this.getBuffetStatisData(this.cid)
            }, interval)
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.swiper-view {
  .sv-header {
    display: flex;
    align-items: center;
    height: 4vh;
    line-height: 4vh;
    font-weight: 600;
    font-size: 16px;
    box-shadow: 0 0 1px #88c7ff inset;
    background: linear-gradient(#065ca1, #001c4d);

    span {
      flex: 1 1 auto;
      text-align: center;

      &:first-child {
        flex: 0 0 200px;
      }
    }
  }

  .sv-nodata {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: calc(100% - 4vh);
  }

  .sv-swiper {
    width: 100%;
    height: calc(100% - 4vh);

    &-slide {
      display: flex;
      align-items: center;

      span {
        flex: 1 1 auto;
        text-align: center;
        color: #00a4f0;

        &:first-child {
          flex: 0 0 200px;
          width: 200px;
          padding: 0 10px;
          color: #fa7310;
          @include text-ellipsis-single;
        }
      }
    }
  }
}
</style>
